module.exports = __webpack_public_path__ + "static/img/sand_8_mini2.e76cf393.png";